
<mat-progress-bar class="progress-fixed" *ngIf="loadingData || !dealershipTableLoadingComplete || !userTableLoadingComplete || !jobsiteTableLoadingComplete || !customerTableLoadingComplete" mode="query"></mat-progress-bar>
<div [class.hidden]="loadingData" style="margin-top: 2%;margin-left: 2%;margin-right: 2%;">
    <div class="button-container">
        <a *ngIf="addUserVisible" class="button" (click)="openAddUserModal()"><i class="material-icons button__icon">face</i><span class="button__text">{{"Add User" | translate | async}}</span></a>
        <a *ngIf="addCustomerVisible" class="button" (click)="openAddCustomerModal()"><i class="material-icons button__icon">people</i><span class="button__text">{{"Add Customer" | translate | async}}</span></a>
        <a *ngIf="addJobsiteVisible" class="button" (click)="openAddJobsiteModal()"><i class="material-icons button__icon">add_location</i><span class="button__text">{{"Add Job Site" | translate | async}}</span></a>
        <a *ngIf="addDealershipVisible" class="button" (click)="openAddDealershipModal()"><i class="material-icons button__icon">location_city</i><span class="button__text">{{"Add Dealership" | translate | async}}</span></a>
        <a *ngIf="addDealerGroupVisible" class="button" (click)="openAddDealerGroupModal()"><i class="material-icons button__icon">location_city</i><span class="button__text">{{"Add Dealer Group" | translate | async}}</span></a>
    </div>
    <div class="panel">
      
        <mat-tab-group>
            <mat-tab [label]="'Users' | translate | async" *ngIf="addUserVisible" [selectedIndex]="defaultTabIndex">
                <div class="input-container filter-table">
                    <span class="input-icon input-icon--mat">
                        <i class="material-icons">search</i>
                    </span>
                    <a class="button"><span class="button__text"  (click)="resetFieldsUserText()">{{"Reset" | translate | async}}</span></a>
                    <input [(ngModel)]="filterUserTableText" type="text" placeholder="{{'Filter user' | translate | async}}" (input)="filterUserText($event)"/>
                    <!--<mat-slide-toggle style="margin-left: 24px;" [(ngModel)]="showPending">Show Pending Users</mat-slide-toggle>-->
                </div>
                <div class="panel__content no-padding">
                    <div>
                        <div style="margin-left: 32%; position:absolute; vertical-align: middle; align-content:center;" *ngIf="loading">
                            <mat-spinner> </mat-spinner>
                          </div>
                        <table class="table table--striped table--full-width " style="width: 100%;display: table;">
                            <thead>
                                <tr>
                                    <th>{{'Full Name' | translate | async}}</th>
                                    <th>{{'Username' | translate | async}}</th>
                                    <th>{{'Email' | translate | async}}</th>
                                    <th>{{'Team' | translate | async}}</th>
                                    <th>{{'Access' | translate | async}}</th>
                                    <th class="align-right">{{'More' | translate | async}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr [class.hidden]="!showPending" *ngFor="let user of pendingUserTableData">
                                    <td style="color: #ff9800;">{{'Pending' | translate | async}}</td>
                                    <td style="color: #ff9800;">{{'Pending' | translate | async}}</td>
                                    <td>{{user.Email | aesDecrypt}}</td>
                                    <td>{{user.TeamName}}</td>
                                    <td>{{user.Access}}</td>
                                    <td class="align-right">
                                        <div>
                                            <button mat-icon-button [matMenuTriggerFor]="pendingUserMenu">
                                                <i class="material-icons">more_vert</i>
                                            </button>
                                            <mat-menu #pendingUserMenu="matMenu">
                                                <button (click)="cancelInvitation(user.InviteId)" mat-menu-item>
                                                    <mat-icon>delete</mat-icon>
                                                    <span>{{'Cancel Invite' | translate | async}}</span>
                                                </button>
                                            </mat-menu>
                                        </div>
                                    </td>
                                </tr>
                                <tr [class.disabled]="user.Disabled" *ngFor="let user of userTableData">
                                <!-- <tr [class.disabled]="user.Disabled" *ngFor="let user of userTableData | filterUserTable: filterUserTableText"> -->
                                  <td>{{user.FullName | aesDecrypt}}</td>
                                  <td>{{user.UserName | aesDecrypt}}</td>
                                    <td><a href="mailto:{{user.Email | aesDecrypt}}">{{user.Email | aesDecrypt}}</a></td>
                                    <td>{{user.TeamName}}</td>
                                    <td>{{user.Access}}</td>
                                    <td class="align-right">
                                        <div>
                                            <button mat-icon-button [matMenuTriggerFor]="userMenu">
                                                <i class="material-icons">more_vert</i>
                                            </button>
                                            <mat-menu #userMenu="matMenu">
                                                <button *ngIf="checkRole('Administrator')" (click)="openEditUserModal(user.UserId)" mat-menu-item>
                                                    <mat-icon>mode_edit</mat-icon>
                                                    <span>{{'Edit' | translate | async}}</span>
                                                </button>
                                                <button *ngIf="checkAccess(1,'Administrator',true)" (click)="OpenAssignmentModal(1,user.UserId)" mat-menu-item>
                                                    <mat-icon>person_add</mat-icon>
                                                    <span>{{'Support Team Access' | translate | async}}</span>
                                                </button>
                                                <button *ngIf="checkAccess(1,'Administrator',true) || checkAccess(2,'Administrator',true)" (click)="OpenAssignmentModal(2,user.UserId)" mat-menu-item>
                                                    <mat-icon>person_add</mat-icon>
                                                    <span>{{'Dealer Group Access' | translate | async}}</span>
                                                </button>
                                                <button *ngIf="checkAccess(1,'Administrator',true) || checkAccess(2,'Administrator',true) || checkAccess(3,'Administrator',true)" (click)="OpenAssignmentModal(3,user.UserId)" mat-menu-item>
                                                    <mat-icon>person_add</mat-icon>
                                                    <span>{{'Dealer Access' | translate | async}}</span>
                                                </button>
                                                <button *ngIf="checkAccess(1,'Administrator',true) || checkAccess(2,'Administrator',true) || checkAccess(3,'Administrator',true) || checkAccess(4,'Administrator',true)" (click)="OpenAssignmentModal(4,user.UserId)" mat-menu-item>
                                                    <mat-icon>person_add</mat-icon>
                                                    <span>{{'Customer Access' | translate | async}}</span>
                                                </button>
                                                <button *ngIf="checkAccess(1,'Administrator',true) || checkAccess(2,'Administrator',true) || checkAccess(3,'Administrator',true)|| checkAccess(4,'Administrator',true) || checkAccess(5,'Administrator',true)" (click)="OpenAssignmentModal(5,user.UserId)" mat-menu-item>
                                                    <mat-icon>person_add</mat-icon>
                                                    <span>{{'Jobsite Access'| translate | async}}</span>
                                                </button>
                                                <button *ngIf="false" (click)="OpenAssignmentModal(6,user.UserId)" mat-menu-item>
                                                    <mat-icon>person_add</mat-icon>
                                                    <span>{{'Equipment Access' | translate | async}}</span>
                                                </button>
                                                <button *ngIf="!user.Disabled" (click)="disableUser(user.UserId)" mat-menu-item>
                                                    <mat-icon>block</mat-icon>
                                                    <span>{{'Disable' | translate | async}}</span>
                                                </button>
                                                <button *ngIf="user.Disabled" (click)="enableUser(user.UserId)" mat-menu-item>
                                                    <mat-icon>lock_open</mat-icon>
                                                    <span>{{'Enable' | translate | async}}</span>
                                                </button>
                                                <button *ngIf="hasMenuAccess" mat-menu-item (click)="resetPassword(user.UserName, user. Email)">
                                                    <mat-icon>lock_open</mat-icon>
                                                    <span>{{'Reset Password' | translate | async}}</span>
                                                </button>
                                            </mat-menu>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <mat-paginator [length]="recordCount"[pageSize]="pageSize"[pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent = $event; onUserPaginateChange($event)">
                </mat-paginator>
            </mat-tab>
            <mat-tab [label]="'Customers' | translate | async" *ngIf="customersTabVisible" >
                <div class="input-container filter-table">
                    <span class="input-icon input-icon--mat" (click)="resetFieldsCusomerText()">
                        <i class="material-icons">search</i>
                    </span>
                    <a class="button"><span class="button__text"  (click)="resetFieldsCusomerText()">{{"Reset" | translate | async}}</span></a>
                    <input [(ngModel)]="filterCustomerTableText" type="text" (input)="filterCustomerText($event)" placeholder="{{'Filter customer' | translate | async}}" />
                </div>
                <div class="panel__content no-padding">
                    <div style="margin-left: 32%; position:absolute; vertical-align: middle; align-content:center;" *ngIf="loading">
                        <mat-spinner> </mat-spinner>
                      </div>
                    <div>
                        <table class="table table--striped table--full-width">
                            <thead>
                                <tr>
                                    <th>{{'Customer' | translate | async}}</th>
                                    <th>{{'Contact Email' | translate | async}}</th>
                                    <th>{{'Job Sites' | translate | async}}/th>
                                    <th>{{'Dealership' | translate | async}}</th>
                                    <th class="align-right">{{'More' | translate | async}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let customer of customerTableData ">
                                    <td>{{customer.CustomerName}}</td>
                                    <td><a href="mailto:{{customer.Email}}">{{customer.Email}}</a></td>
                                    <td>{{customer.JobsiteCount}}</td>
                                    <td>{{customer.DealershipName}}</td>
                                    <td class="align-right">
                                        <div>
                                            <button mat-icon-button [matMenuTriggerFor]="implementMoreMenu">
                                                <i class="material-icons">more_vert</i>
                                            </button>
                                            <mat-menu #implementMoreMenu="matMenu">
                                                <button (click)="openEditCustomerModal(customer.CustomerId)" mat-menu-item>
                                                    <mat-icon>mode_edit</mat-icon>
                                                    <span>{{'Edit' | translate | async}}</span>
                                                </button>
                                                <button *ngIf="checkAccess(1,'Administrator',true) || checkAccess(2,'Administrator',true) || checkAccess(4,'Administrator',true)" (click)="OpenAssignmentModal(8,customer.CustomerId)" mat-menu-item>
                                                    <mat-icon>person_add</mat-icon>
                                                    <span>{{'Dealer Group Access' | translate | async}}</span>
                                                </button>
                                                <button *ngIf="checkAccess(1,'Administrator',true) || checkAccess(2,'Administrator',true) || checkAccess(4,'Administrator',true)" (click)="OpenAssignmentModal(10,customer.CustomerId)" mat-menu-item>
                                                    <mat-icon>person_add</mat-icon>
                                                    <span>{{'Dealer Access' | translate | async}}</span>
                                                </button>
                                                <button *ngIf="showCustomerNotes" (click)="openCustomerNote(customer.CustomerId)" mat-menu-item>
                                                  <mat-icon>speaker_notes</mat-icon>
                                                  <span>{{'Customer Notes' | translate | async}}</span>
                                              </button>
                                            </mat-menu>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <mat-paginator [length]="customerRecordCount"[pageSize]="pageSize"[pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent = $event; onCustomerPaginateChangeCustomer($event)">
                </mat-paginator>
            </mat-tab>
            <mat-tab [label]="'Job Sites' | translate | async">
                <div class="input-container filter-table">
                    <span class="input-icon input-icon--mat">
                        <i class="material-icons">search</i>
                    </span>
                    <a class="button"><span class="button__text"  (click)="resetFieldsJobsiteext()">{{"Reset" | translate | async}}</span></a>
                    <input [(ngModel)]="filterJobsiteTableText" type="text" (input)="filterJobsiteText($event)"  placeholder="{{'Filter job site' | translate | async}} " />
                </div>
                <div class="panel__content no-padding">
                    <div>
                        <table class="table table--striped table--full-width">
                            <thead>
                                <tr>
                                    <th>{{'Job Site' | translate | async}}</th>
                                    <th>{{'Country' | translate | async}}</th>
                                    <th>{{'Customer'  | translate | async}}</th>
                                    <th class="align-right">{{'More' | translate | async}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let jobsite of jobsiteTableData ">
                                    <td>{{jobsite.JobsiteName}}</td>
                                    <td>{{jobsite.Country}}</td>
                                    <td>{{jobsite.CustomerName}}</td>
                                    <td class="align-right">
                                        <div>
                                            <button mat-icon-button [matMenuTriggerFor]="implementMoreMenu">
                                                <i class="material-icons">more_vert</i>
                                            </button>
                                            <mat-menu #implementMoreMenu="matMenu">
                                                <button (click)="openEditJobsiteModal(jobsite.JobsiteId)" mat-menu-item>
                                                    <mat-icon>mode_edit</mat-icon>
                                                    <span>{{'Edit' | translate | async}}</span>
                                                </button>
                                                <button *ngIf="checkAccess(1,'Administrator',true) || checkAccess(2,'Administrator',true) || checkAccess(4,'Administrator',true) || checkAccess(5,'Administrator',true)" (click)="OpenAssignmentModal(9,jobsite.JobsiteId)" mat-menu-item>
                                                    <mat-icon>person_add</mat-icon>
                                                    <span>{{'Dealer Access'  | translate | async}}</span>
                                                </button>
                                            </mat-menu>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <mat-paginator [length]="jobsiteRecordCount"[pageSize]="pageSize"[pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent = $event; onJobsitePaginateChange($event)">
                </mat-paginator>
            </mat-tab>
            <mat-tab [label]="'Dealerships' | translate | async" *ngIf="dealershipsTabVisible">
              <div class="input-container filter-table">
                <span class="input-icon input-icon--mat">
                  <i class="material-icons">search</i>
                </span>
                <a class="button"><span class="button__text" (click)="resetDealerShiptext()">{{"Reset" | translate | async}}</span></a>
                <input [(ngModel)]="filterDealershipTableText" type="text" (input)="filterDealerShipText($event)" placeholder="{{'Filter dealership' | translate | async}}  " />
              </div>

              <div class="panel__content no-padding">
                <div>
                  <table class="table table--striped table--full-width">
                    <thead>
                      <tr>
                        <th>{{'Dealership Name' | translate | async}}</th>
                        <th>{{'Dealer Group' | translate | async}}</th>
                        <th class="align-right">{{'More' | translate | async}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let dealership of dealershipTableData ">
                        <td>{{dealership.DealershipName}}</td>
                        <td>{{dealership.DealershipGroupName}}</td>
                        <td class="align-right">
                          <div>
                            <button mat-icon-button [matMenuTriggerFor]="implementMoreMenu">
                              <i class="material-icons">more_vert</i>
                            </button>
                            <mat-menu #implementMoreMenu="matMenu">
                              <button (click)="openEditDealershipModal(dealership.DealershipId)" mat-menu-item>
                                <mat-icon>mode_edit</mat-icon>
                                <span>{{'Edit'  | translate | async}}</span>
                              </button>
                              <button *ngIf="checkAccess(1,'Administrator',true) || checkAccess(2,'Administrator',true) || checkAccess(4,'Administrator',true) || checkAccess(5,'Administrator',true)" (click)="OpenAssignmentModal(11,dealership.DealershipId)" mat-menu-item>
                                <mat-icon>nature_people</mat-icon>
                                <span>{{'Jobsite Access'| translate | async}}</span>
                              </button>
                              <button *ngIf="checkAccess(1,'Administrator',true) || checkAccess(2,'Administrator',true)" (click)="OpenAssignmentModal(12,dealership.DealershipId)" mat-menu-item>
                                <mat-icon>person_add</mat-icon>
                                <span>{{'Customer Access' | translate | async}}</span>
                              </button>
                              <button *ngIf="checkAccess(1,'Administrator',true) || checkAccess(2,'Administrator',true)" (click)="OpenAssignmentModal(7,dealership.DealershipId)" mat-menu-item>
                                <mat-icon>nature_people</mat-icon>
                                <span>{{'Dealer Group Access' | translate | async}}</span>
                              </button>
                              <!-- <button mat-menu-item [matMenuTriggerFor]="brandedstyles">
                      <mat-icon>style</mat-icon>
                      <span>Branded Styles</span>
                  </button> -->
                            </mat-menu>
                            <!-- <mat-menu #brandedstyles="matMenu">
                    <button *ngFor="let style of dealership.BrandedStyles" (click)="openEditDealershipBrandingModal(style.Id)" mat-menu-item>{{style.Name}}</button>
                    <button mat-menu-item (click)="openAddBrandedStyleModal(dealership.DealershipId, dealership.DealershipName)">
                        <mat-icon>add</mat-icon>
                        <span>Add New</span>
                    </button>
                </mat-menu> -->
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <mat-paginator [length]="dealerRecordCount" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                             (page)="pageEvent = $event; onDealerShipPaginateChange($event)">
              </mat-paginator>
            </mat-tab>
            <mat-tab [label]="'Dealer Group' | translate | async"  *ngIf="addDealerGroupVisible">
              <div class="input-container filter-table">
                <span class="input-icon input-icon--mat">
                  <i class="material-icons">search</i>
                </span>
                <a class="button"><span class="button__text" (click)="resetDealerGrouptext()">{{"Reset" | translate | async}}</span></a>
                <input [(ngModel)]="filterDealerGroupTableText" type="text" placeholder="{{'Filter dealer group' | translate | async}} " />
              </div>
                <div class="panel__content no-padding">
                    <div>
                        <table class="table table--striped table--full-width">
                            <thead>
                                <tr>
                                    <th>{{'Dealer Group' | translate | async}}</th>
                                    <th class="align-right">{{'More' | translate | async}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let dealerGroup of dealerGroupTableData | filterDealerGroupTable: filterDealerGroupTableText">
                                    <td>{{dealerGroup.Name}}</td>
                                    <td class="align-right">
                                        <div>
                                            <button mat-icon-button [matMenuTriggerFor]="implementMoreMenu">
                                                <i class="material-icons">more_vert</i>
                                            </button>
                                            <mat-menu #implementMoreMenu="matMenu">
                                                <button (click)="openEditDealerGroup(dealerGroup.Id)" mat-menu-item>
                                                    <mat-icon>mode_edit</mat-icon>
                                                    <span>{{'Edit' | translate | async}}</span>
                                                </button>
                                            </mat-menu>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
